import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTextSize } from "@fortawesome/pro-solid-svg-icons";

import { SpaceType } from "../../../../../store";

import { TextMarkerDecoration } from "./TextMarkerDecoration";
import { Point, PointLiteral } from "../shared";

export class FreeTextMarkerDecoration extends TextMarkerDecoration {
  get default() {
    return {
      ...super.default,
      textSizeCP: new Point(0.33333, 0), // TODO make text size uniform
      lineHeightCP: new Point(0, 0.5),
    };
  }

  get defaultReactiveState() {
    return {
      text: undefined as undefined | string,
    };
  }

  buildControlPoints() {
    const marker = this;
    const baseControlPoints = super.buildControlPoints();
    const ownControlPoints = {
      get center(): Point {
        return baseControlPoints.center;
      },
      set center(value: PointLiteral | Point) {
        const start = { x: marker.state.center.x, y: marker.state.center.y };
        baseControlPoints.center = value;
        marker.state.lineHeightCP.x += marker.state.center.x - start.x;
        marker.state.lineHeightCP.y += marker.state.center.y - start.y;
      },

      get lineHeightCP(): Point {
        return marker.state.lineHeightCP;
      },
      set lineHeightCP(value: PointLiteral | Point) {
        marker.constrainRadius(value, marker.state.lineHeightCP, marker.state.center, 0.2, 1);
        marker.constrainVertical(marker.state.lineHeightCP, marker.state.lineHeightCP, marker.state.center);
      },
    };

    return this.mergeControlPointDescriptors(baseControlPoints, ownControlPoints);
  }

  get lineHeightCP() { return this.controlPoints.lineHeightCP; }

  get lineHeight() {
    return this.center.distanceTo(this.lineHeightCP);
  }

  textContentLength(): number {
    return Math.max(
      ...(this.reactiveState.text?.split('\n').map((s) => s.length / 1.5) ?? [1 / 1.5]), // XXX: I don't understand why the 1.5 factor fixes it
    );
  }

  Content({ space, extraProps }: { space: SpaceType, extraProps: Record<string, string> }) {
    return (
      <text
        x={this.reactiveState.text === undefined ? this.center.x : this.center.x - 1}
        y={this.reactiveState.text === undefined ? this.center.y : this.center.y - this.lineHeight}
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize={this.textSizePx(space)}
        lengthAdjust='spacingAndGlyphs'
        className="marker-decoration"
        {...extraProps}
      >
        {(this.reactiveState.text === undefined
          ? ''
          : this.reactiveState.text.split('\n')
            .map((line) => (
              <tspan
                key={line}
                x={0}
                dy={this.lineHeight}
              >
                {line}
              </tspan>
            ))
        )}
      </text>
    );
  }

  Thumbnail() {
    return (
      <FontAwesomeIcon icon={faTextSize} />
    );
  }

  Configuration() {
    return (
      <>
        <label htmlFor="marker-free-text">Text</label>
        <textarea
          id="marker-free-text"
          key="free-text-marker-decoration-textarea"
          className="w-100"
          value={this.reactiveState.text}
          onChange={(e) => { this.reactiveState.text = e.target.value; }}
        />
      </>
    );
  }

  title = 'Free Text';
}
